import { IMobileDevice } from "../interfaces/mobile-device.interface";

export class MobileDevice implements IMobileDevice {
  mobileDevicepk: number;
  mobileDeviceName: string;
  mobileDeviceLTEProvider: string;
  mobileDeviceSimNumber: string;
  mobileDeviceModelSupplier: string;

  constructor(mobileDevice: IMobileDevice) {
    Object.keys(mobileDevice).map(key => this[key] = mobileDevice[key]);
  }
}